module.exports = __webpack_public_path__ + "static/img/MARK_WAUGH.6177fb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MARK_WAUGH.jpg
// module id = 4lSD
// module chunks = 0